import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

// Utility for setting up fetch config
const fetchWithSession = async (url, options = {}, isProtected = true) => {
  const sessionToken = getCookie();

  if (isProtected && !sessionToken) {
    return handleSessionExpire();
  }

  const headers = {
    'Content-Type': 'application/json',
    ...(isProtected && { Authorization: `Bearer ${sessionToken}` }),
    ...options.headers,
  };

  try {
    const response = await fetch(url, {
      ...options,
      headers,
    });

    const contentType = response.headers.get('Content-Type');
    const isJson = contentType && contentType.includes('application/json');
    const data = isJson ? await response.json() : null;

    if (data?.session) return handleSessionExpire();

    if (!response.ok) {
      const errorMessage = data?.error || 'Request failed';

      throw new Error(errorMessage);
    }

    return data;
  } catch (err) {
    console.error(`API Error: ${url}`, err);

    throw err;
  }
};

export const fetchJobRoles = () =>
  fetchWithSession(
    `${API_URL}/fetch-career-job-roles`,
    {
      method: 'GET',
    },
    false
  );

export const addJobRoles = (addedJobs) =>
  fetchWithSession(`${API_URL}/add-career-job-roles`, {
    method: 'POST',
    body: JSON.stringify(addedJobs),
  });

export const updateJobRoles = (updatedJobs) =>
  fetchWithSession(`${API_URL}/update-career-job-roles`, {
    method: 'PUT',
    body: JSON.stringify(updatedJobs),
  });

export const deleteJobRoles = (id) =>
  fetchWithSession(`${API_URL}/delete-job-roles/${id}`, {
    method: 'DELETE',
  });
